import { create } from 'zustand';

import {
  Zee,
  ZeeBackground,
  ZeeFinancial,
  ZeeOtherFinancial,
} from '@/types/zee.type';

export interface ZeeState {
  zee: Zee | undefined;
  zees: Zee[] | undefined;
  zeeFinancial: ZeeFinancial | undefined;
  zeeOtherFinancial: ZeeOtherFinancial | undefined;
  zeeBackground: ZeeBackground | undefined;
  setZee: (zee: Zee) => void;
  setZees: (zees: Zee[]) => void;
  setZeeFinancial: (zeeFinancial: ZeeFinancial) => void;
  setZeeOtherFinancial: (zeeOtherFinancial: ZeeOtherFinancial) => void;
  setZeeBackground: (zeeBackground: ZeeBackground) => void;
}

const useZeeStore = create<ZeeState>((set) => ({
  zee: undefined,
  zees: undefined,
  zeeFinancial: undefined,
  zeeOtherFinancial: undefined,
  zeeBackground: undefined,
  setZee: (zee: Zee) => set(() => ({ zee })),
  setZees: (zees: Zee[]) => set(() => ({ zees })),
  setZeeFinancial: (zeeFinancial: ZeeFinancial) =>
    set(() => ({ zeeFinancial })),
  setZeeOtherFinancial: (zeeOtherFinancial: ZeeOtherFinancial) =>
    set(() => ({ zeeOtherFinancial })),
  setZeeBackground: (zeeBackground: ZeeBackground) =>
    set(() => ({ zeeBackground })),
}));

export { useZeeStore };
